import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useThemeStore } from "context/useThemeStore";
import { useUserStore } from "context/useUserStore";
import UserMenu from "./UserMenu";
import ProfileModal from "./ProfileModal";
import { School } from "lucide-react";
import { useWebSocket } from "context/useWebsocketStore";

const auth0RedirectUrl = "https://ittterni.eduprompt.it";

const Header = ({
  collapsed,
  handleLanguageChange,
  language,

  standAlone,
}) => {
  const { user, logout } = useAuth0();
  const { appUser, userData, userWallet, setUserWallet } = useUserStore();
  const { theme, setTheme } = useThemeStore();
  const { subscribe, leave, isReady } = useWebSocket();
  const [showProfileModal, setShowProfileModal] = useState(false);

  const [userCredit, setUserCredit] = useState({
    totalCredits: 0,
    creditsUsed: 0,
    creditsAvailable: 0,
    usedPercentage: 0,
    creditsFrozen: 0,
    frozenPercentage: 0,
  });

  useEffect(() => {
    if (userData.selected_school_id) {
      const selectedSchoolWalletCredits = userWallet?.credits.find((c) => c.school_id === userData?.selected_school_id);
      const totalCredits =
        (selectedSchoolWalletCredits?.credit_available ?? 0) + (selectedSchoolWalletCredits?.credit_spent ?? 0);
      const creditsUsed = selectedSchoolWalletCredits?.credit_spent ?? 0;
      const creditsFrozen = selectedSchoolWalletCredits?.credit_frozen ?? 0;
      const creditsAvailable =
        (selectedSchoolWalletCredits?.credit_available ?? 0) - +(selectedSchoolWalletCredits?.credit_frozen ?? 0);
      const usedPercentage = totalCredits > 0 ? (creditsUsed / totalCredits) * 100 : 0;
      const frozenPercentage = totalCredits > 0 ? (creditsFrozen / totalCredits) * 100 : 0;

      setUserCredit({
        totalCredits,
        creditsUsed,
        creditsAvailable,
        creditsFrozen,
        usedPercentage,
        frozenPercentage,
      });
    }
  }, [userData.selected_school_id, userWallet]);

  useEffect(() => {
    if (userWallet && userWallet.id && isReady && (appUser?.role === "teacher" || appUser?.role === "administrative")) {
      subscribe(`wallet.${userWallet?.id}`, ".wallet.update", (data) => {
        console.log("wallet update : ", data);
        setUserWallet(data.wallet);
      });
    }
  }, [userWallet, appUser]);

  const handleLogout = () => {
    console.log("Logging out...", window.location.origin);
    logout({
      logoutParams: {
        returnTo: auth0RedirectUrl,
      },
    });
  };

  return (
    <React.Fragment>
      <div
        className="fixed top-0 z-40 h-16 flex items-center px-4 transition-all duration-300 backdrop-blur-md border-b"
        style={{
          borderBottomColor: "var(--border-color)", // use your custom color
          borderBottomWidth: "1px",
          backgroundColor: "var(--secondary-bg)",
          width: !collapsed ? "calc(100% - 250px)" : "calc(100% - 60px)",
          ...(standAlone && { width: "100%", marginLeft: 0 }),
        }}
      >
        {window.location.pathname !== "/schools" && window.location.pathname !== "/" && (
          <>
            <School size={16} className="title-icon" />
            <span className="ml-2 text-sm font-medium page-title">{userData?.selected_school?.name}</span>
          </>
        )}

        <div className="ml-auto">
          <UserMenu
            user={user}
            language={language}
            handleLanguageChange={handleLanguageChange}
            userCredit={userCredit}
            appUser={appUser}
            handleLogout={handleLogout}
          />
        </div>
      </div>
      <ProfileModal
        open={showProfileModal}
        onClose={() => {
          setShowProfileModal(false);
        }}
        theme={theme}
      />
    </React.Fragment>
  );
};

export default Header;
